
export default {
  getColor,
  getShadeVariant
}

export function getColor(name, variant) {
  let colorVariants = {
    'yellow': yellow,
    'orange': orange,
    'green': green,
    'blue': blue,
    'teal': teal,
  }[name]

  if ( !variant )
    return colorVariants['400']

  return colorVariants[variant]
}

export function getShadeVariant(index) {
  return [
    '200', '50',  // Leave out the default color variant
    'A100', 'A400', 'A700'
  ][index % 6]
}

// Variants for each colour
// based on the: 2014 Material Design color palettes
// Palettes are at the bottom of material.io/design/color

let green = {
  '50': 0xE8F5E9,
  '100': 0xC8E6C9,
  '200': 0xA5D6A7,
  '300': 0x81C784,
  '400': 0x66BB6A,
  '500': 0x4CAF50,
  '600': 0x43A047,
  '700': 0x388E3C,
  '800': 0x2E7D32,
  '900': 0x1B5E20,
  'A100': 0xB9F6CA,
  'A200': 0x69F0AE,
  'A400': 0x00E676,
  'A700': 0x00C853,
}
let teal = {
	'50': 0xE0F2F1,
	'100': 0xB2DFDB,
	'200': 0x80CBC4,
	'300': 0x4DB6AC,
	'400': 0x26A69A,
	'500': 0x009688,
	'600': 0x00897B,
	'700': 0x00796B,
	'800': 0x00695C,
	'900': 0x004D40,
	'A100': 0xA7FFEB,
	'A200': 0x64FFDA,
	'A400': 0x1DE9B6,
	'A700': 0x00BFA5,
}
let yellow = {
  '50': 0xFFFDE7,
  '100': 0xFFF9C4,
  '200': 0xFFF59D,
  '300': 0xFFF176,
  '400': 0xFFEE58,
  '500': 0xFFEB3B,
  '600': 0xFDD835,
  '700': 0xFBC02D,
  '800': 0xF9A825,
  '900': 0xF57F17,
  'A100': 0xFFFF8D,
  'A200': 0xFFFF00,
  'A400': 0xFFEA00,
  'A700': 0xFFD600,
}

let orange = {
  '50': 0xFFF3E0,
  '100': 0xFFE0B2,
  '200': 0xFFCC80,
  '300': 0xFFB74D,
  '400': 0xFFA726,
  '500': 0xFF9800,
  '600': 0xFB8C00,
  '700': 0xF57C00,
  '800': 0xEF6C00,
  '900': 0xE65100,
  'A100': 0xFFD180,
  'A200': 0xFFAB40,
  'A400': 0xFF9100,
  'A700': 0xFF6D00,
}

let blue = {
  '50': 0xE3F2FD,
  '100': 0xBBDEFB,
  '200': 0x90CAF9,
  '300': 0x64B5F6,
  '400': 0x42A5F5,
  '500': 0x2196F3,
  '600': 0x1E88E5,
  '700': 0x1976D2,
  '800': 0x1565C0,
  '900': 0x0D47A1,
  'A100': 0x82B1FF,
  'A200': 0x448AFF,
  'A400': 0x2979FF,
  'A700': 0x2962FF,
}
